import { render, staticRenderFns } from "./ConfidentialPolicyModal.vue?vue&type=template&id=3d5498e7&"
import script from "./ConfidentialPolicyModal.vue?vue&type=script&lang=js&"
export * from "./ConfidentialPolicyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports